import { render, staticRenderFns } from "./ModalLayout.vue?vue&type=template&id=288c025b"
import script from "./ModalLayout.ts?vue&type=script&lang=ts&external"
export * from "./ModalLayout.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports